import React from 'react';
import { Megaphone, HeartHandshake } from 'lucide-react';
export function Exclusives() {
  return <section className="py-12 sm:py-20" data-id="element-75">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-76">
        <div className="rounded-2xl border border-gold-dim bg-[linear-gradient(135deg,#1a1100,#0f0c00)] p-8 sm:p-12" data-id="element-77">
          <div className="mb-6 inline-flex items-center gap-2 rounded bg-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-[#111]" data-id="element-78">
            ★ EXCLUSIVOS MEGAPACK
          </div>
          <h2 className="mb-3 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-79">
            ¿Qué agrega el Megapack
            <br data-id="element-80" />
            que no tiene el Kit?
          </h2>
          <p className="max-w-[560px] text-[15px] text-text" data-id="element-81">
            Para los que no se conforman con vender una vez y quieren un negocio
            con marca propia, clientes fijos y un sistema que trabaje aunque no
            estés mirando el teléfono.
          </p>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-82">
            <div className="rounded-lg border border-gold/15 bg-black/30 p-6" data-id="element-83">
              <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-gold shadow-[0_0_24px_rgba(201,168,76,0.25)]" data-id="element-84">
                <Megaphone className="h-7 w-7 text-[#111]" strokeWidth={1.75} data-id="element-85" />
              </div>
              <div className="mb-2 inline-block rounded bg-gold/15 px-2 py-0.5 text-[10px] font-bold tracking-[0.08em] text-gold" data-id="element-86">
                T7
              </div>
              <div className="mb-2 text-[15px] font-semibold text-white" data-id="element-87">
                Tu marca en redes
              </div>
              <div className="mb-3 text-[13px] leading-[1.65] text-text" data-id="element-88">
                Cómo hacer que te busquen a vos y no a la competencia. Sin pagar
                publicidad. Sin ser influencer. Con 2 horas de trabajo al mes.
              </div>
              <ul className="flex flex-col gap-1.5" data-id="element-89">
                {['Perfil que vende: qué poner en la bio, la foto y el primer post', 'Calendario semanal de contenido (qué publicar cada día)', 'Fórmula de reel de 30 segundos que genera consultas', 'Métricas de negocio vs métricas de vanidad: cuál importa'].map((bullet, i) => <li key={i} className="flex items-start gap-2 text-[12px] text-muted" data-id="element-90">
                    <span className="mt-0.5 shrink-0 text-[10px] text-gold" data-id="element-91">
                      ★
                    </span>
                    {bullet}
                  </li>)}
              </ul>
            </div>

            <div className="rounded-lg border border-gold/15 bg-black/30 p-6" data-id="element-92">
              <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-gold shadow-[0_0_24px_rgba(201,168,76,0.25)]" data-id="element-93">
                <HeartHandshake className="h-7 w-7 text-[#111]" strokeWidth={1.75} data-id="element-94" />
              </div>
              <div className="mb-2 inline-block rounded bg-gold/15 px-2 py-0.5 text-[10px] font-bold tracking-[0.08em] text-gold" data-id="element-95">
                T8
              </div>
              <div className="mb-2 text-[15px] font-semibold text-white" data-id="element-96">
                Clientes que vuelven y te recomiendan
              </div>
              <div className="mb-3 text-[13px] leading-[1.65] text-text" data-id="element-97">
                El sistema postventa que convierte una venta en ingresos
                predecibles. Sin gastar en publicidad ni buscar clientes nuevos
                todo el tiempo.
              </div>
              <ul className="flex flex-col gap-1.5" data-id="element-98">
                {['Sistema postventa en 3 pasos (desde que cobras hasta que vuelven a comprarte)', 'Programa de referidos: cómo hacer que tus clientes te traigan más clientes', 'Calendario anual de contacto con tu base de clientes', 'Ciclo completo: Día 0 → cliente fidelizado'].map((bullet, i) => <li key={i} className="flex items-start gap-2 text-[12px] text-muted" data-id="element-99">
                    <span className="mt-0.5 shrink-0 text-[10px] text-gold" data-id="element-100">
                      ★
                    </span>
                    {bullet}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-9 rounded-lg border border-gold/20 bg-black/30 p-6 text-center" data-id="element-101">
            <div className="mb-2 text-[13px] text-muted" data-id="element-102">
              La diferencia entre el Kit y el Megapack
            </div>
            <div className="mb-1.5 font-serif text-[22px] text-white" data-id="element-103">
              Solo <span className="text-gold" data-id="element-104">$8.000</span> más.
            </div>
            <div className="text-[13px] text-text" data-id="element-105">
              Eso es lo que sale una pulsera de plata 925 en el Once. Los Tomos
              7 y 8 son los que hacen que no tengas que salir a buscar clientes
              nuevos todos los meses.{' '}
              <strong className="font-bold text-white" data-id="element-106">
                La ecuación cierra sola.
              </strong>
            </div>
          </div>
        </div>
      </div>
    </section>;
}